(function () {
  var MODAL_ID = 'bz-refer-copy-modal';

  function getModal() {
    var modal = document.getElementById(MODAL_ID);
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'bz-refer-copy-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('aria-labelledby', 'bz-refer-copy-modal-title');
    modal.innerHTML =
      '<div class="bz-refer-copy-modal__panel">' +
      '<p id="bz-refer-copy-modal-title" class="bz-refer-copy-modal__message">Referral link copied to clipboard !</p>' +
      '<button type="button" class="bz-refer-copy-modal__ok">OK</button>' +
      '</div>';
    document.body.appendChild(modal);

    modal.querySelector('.bz-refer-copy-modal__ok').addEventListener('click', function () {
      hideModal(modal);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) hideModal(modal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-visible')) {
        hideModal(modal);
      }
    });

    return modal;
  }

  function showModal(modal) {
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    modal.querySelector('.bz-refer-copy-modal__ok').focus();
  }

  function hideModal(modal) {
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
  }

  function copyText(text) {
    if (!text) return Promise.reject();

    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function getReferralLink(widget) {
    if (!widget) return '';

    var copyTextEl = widget.querySelector('.yotpo-copy-text');
    if (copyTextEl && copyTextEl.textContent.trim()) {
      return copyTextEl.textContent.replace(/\s+/g, ' ').trim();
    }

    var textarea = widget.querySelector('.yotpo-main-share-body-textarea, .yotpo-referral-widget-form textarea');
    if (textarea && textarea.value) {
      var urlMatch = textarea.value.match(/https?:\/\/[^\s"'<>]+/);
      if (urlMatch) return urlMatch[0].trim();
    }

    var smsButton = widget.querySelector('.yotpo-sms-share-button');
    if (smsButton) {
      var smsHref = smsButton.getAttribute('href') || smsButton.dataset.referralLink;
      if (smsHref && /https?:\/\//.test(smsHref)) return smsHref.trim();
    }

    var match = widget.textContent.match(/https:\/\/[^\s"'<>]+/);
    return match ? match[0].trim() : '';
  }

  var TRIGGER_SELECTOR = [
    '.yotpo-widget-referral-share .yotpo-main-copy-link',
    '.yotpo-widget-referral-share .yotpo-referral-widget-form button.yotpo-submit-form',
    '.yotpo-widget-referral-share .yotpo-referral-widget-form .yotpo-submit-form .yotpo-button-style',
    '.yotpo-widget-referral-share .yotpo-referral-widget-form .yotpo-sms-share-button',
    '.yotpo-widget-referral-share .yotpo-referral-widget-form .yotpo-sms-share-button button',
  ].join(',');

  function findTrigger(target) {
    if (!target || !target.closest) return null;
    return target.closest(TRIGGER_SELECTOR);
  }

  /*
   * 事件委托：无论 "Refer your friends" 按钮何时被 Yotpo 渲染或重渲染，
   * 都能在捕获阶段拦截点击，复制推荐链接并弹出提示（保留原复制功能）。
   */
  document.addEventListener(
    'click',
    function (event) {
      var trigger = findTrigger(event.target);
      if (!trigger) return;

      var widget = trigger.closest('.yotpo-widget-referral-share');

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      copyText(getReferralLink(widget))
        .catch(function () {})
        .finally(function () {
          showModal(getModal());
        });
    },
    true
  );
})();
